import { render, staticRenderFns } from "./PowerTeams.vue?vue&type=template&id=a7346226&scoped=true&"
import script from "./PowerTeams.vue?vue&type=script&lang=js&"
export * from "./PowerTeams.vue?vue&type=script&lang=js&"
import style0 from "./PowerTeams.vue?vue&type=style&index=0&id=a7346226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7346226",
  null
  
)

export default component.exports